import { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag, Menu, X, LockKeyhole, UserRound } from "lucide-react";
import { Logo } from "./Logo";
import { useCart } from "@/lib/cart";
import { scrollToId } from "@/lib/api";

const LINKS = [
  { id: "catalogo", label: "Catalogo", testid: "navbar-catalog-link" },
  { id: "servizi", label: "Servizi", testid: "navbar-services-link" },
  { id: "richiesta", label: "Richiedi info", testid: "navbar-request-link" },
];

export const Navbar = () => {
  const { count, setOpen } = useCart();
  const [menu, setMenu] = useState(false);
  const go = (id) => { setMenu(false); scrollToId(id); };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-4 z-50 px-4"
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between rounded-full border border-fg/10 bg-[#f3f3f4]/75 py-2 pl-4 pr-2 backdrop-blur-xl">
        <Link to="/" data-testid="navbar-logo-link" onClick={() => go("top")}><Logo /></Link>
        <div className="hidden items-center gap-1 md:flex">
          {LINKS.map((l) => (
            <button key={l.id} data-testid={l.testid} onClick={() => go(l.id)}
              className="rounded-full px-4 py-2 text-sm text-fg2 transition-colors hover:bg-fg/5 hover:text-fg">
              {l.label}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-1.5">
          <Link to="/account" data-testid="navbar-account-button" aria-label="Il mio account"
            className="flex h-10 w-10 items-center justify-center rounded-full text-fg2 transition-colors hover:bg-fg/5 hover:text-fg">
            <UserRound className="h-4 w-4" />
          </Link>
          <Link to="/admin" data-testid="navbar-admin-button" aria-label="Area riservata"
            className="hidden h-10 w-10 items-center justify-center rounded-full text-mist transition-colors hover:bg-fg/5 hover:text-fg sm:flex">
            <LockKeyhole className="h-4 w-4" />
          </Link>
          <button data-testid="navbar-cart-button" onClick={() => setOpen(true)}
            className="relative flex h-10 items-center gap-2 rounded-full bg-[var(--paper)] px-4 text-sm font-semibold text-[var(--ink)] transition-transform active:scale-95">
            <ShoppingBag className="h-4 w-4" />
            <span className="hidden sm:inline">Carrello</span>
            <motion.span key={count} initial={{ scale: 0.4 }} animate={{ scale: 1 }} data-testid="navbar-cart-count"
              className="flex h-5 min-w-5 items-center justify-center rounded-full bg-[var(--volt)] px-1 text-[11px] text-[var(--ink)]">
              {count}
            </motion.span>
          </button>
          <button data-testid="navbar-mobile-menu" onClick={() => setMenu((m) => !m)} aria-label="Menu"
            className="flex h-10 w-10 items-center justify-center rounded-full text-fg md:hidden">
            {menu ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>
      <AnimatePresence>
        {menu && (
          <motion.div initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }}
            className="mx-auto mt-2 max-w-6xl rounded-3xl border border-fg/10 bg-[#f3f3f4]/95 p-3 backdrop-blur-xl md:hidden">
            {LINKS.map((l) => (
              <button key={l.id} data-testid={`mobile-${l.testid}`} onClick={() => go(l.id)}
                className="block w-full rounded-2xl px-4 py-3 text-left font-display text-2xl text-fg hover:bg-fg/5">
                {l.label}
              </button>
            ))}
            <Link to="/admin" data-testid="mobile-navbar-admin-link" className="block px-4 py-3 text-sm text-mist">Area riservata</Link>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
